import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormCreatorService, TypeChecker } from 'lib-base';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Subscription } from 'rxjs';

export interface IFormConfigurationOptions {
  getFormGroup(): FormGroup;
}

@Component({
  selector: 'app-global-options',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule,
    AccordionModule, InputTextModule, ButtonModule
  ],
  templateUrl: './global-options.component.html',
  styleUrl: './global-options.component.scss'
})
export class GlobalOptionsComponent implements OnDestroy {
  readonly MAX_TITLE_LENGTH = 250;
  typeChecker = TypeChecker;

  private _updateSubscription !: Subscription | undefined;
  formGroup !: FormGroup;

  constructor(public fc: FormCreatorService, private readonly _fb: FormBuilder) {
    this.initialize();
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  //#region Getters

  get Page() {
    return this.fc.ConfigurationSection.page;
  }

  get control() {
    return this.fc.ConfigurationSection.control;
  }
  //#endregion Getters

  initialize(){
    this.destroy();
    this.setGlobalFormGroup();
    this.setGlobalUpdateSubscription();
  }

  destroy() {
    if (this._updateSubscription) {
      this._updateSubscription.unsubscribe();
    }
  }

  private setGlobalFormGroup() {
    this.formGroup = this._fb.group({
      general: this._fb.group({        
      }),
    });
  }

  private setGlobalUpdateSubscription() {
    this._updateSubscription = this.formGroup.get('general')?.valueChanges.subscribe((value) => {      
      if (this.formGroup.get('general')?.invalid) return;
    });
  }
}
